import { Validators } from '@angular/forms';
import { CustomValidatorsFactory } from 'src/app/base/shared/validators/custom-validators-factory';
import {
  ClientDTO,
  CreateClientDTO,
  SortDirection,
  UpdateClientDTO,
} from 'src/app/base/models/models.swagger.generated';
import { defineDynamicEntityDefinition, textColumn, booleanColumn } from 'src/app/base/shared/dynamic/dynamic-entity-definition';

type ClientEditModel = UpdateClientDTO;

export const clientDynamicDefinition = defineDynamicEntityDefinition<ClientDTO, CreateClientDTO, ClientEditModel>({
  entityName: 'client',
  primaryKey: 'id',
  activeField: 'isActive',
  defaultSort: {
    field: 'Name',
    direction: SortDirection.Ascending,
  },
  grid: {
    searchFields: ['name', 'address', 'zip', 'city', 'email', 'phoneNumber'],
    columns: [
      { field: 'id', headerKey: 'i18n.shared.fields.id', type: 'number', visible: false, sortable: false, allowFiltering: false },
      textColumn<ClientDTO>('name', 'i18n.shared.fields.name'),
      textColumn<ClientDTO>('address', 'i18n.shared.fields.address'),
      textColumn<ClientDTO>('zip', 'i18n.shared.fields.zip', { width: '110px' }),
      textColumn<ClientDTO>('city', 'i18n.shared.fields.city'),
      textColumn<ClientDTO>('email', 'i18n.shared.fields.email'),
      textColumn<ClientDTO>('phoneNumber', 'i18n.shared.fields.phone'),
      booleanColumn<ClientDTO>('isActive', 'i18n.shared.fields.active'),
    ],
  },
  form: {
    fields: [
      {
        key: 'id',
        labelKey: 'i18n.shared.fields.id',
        control: 'number',
        hiddenOnAdd: true,
        hiddenOnEdit: true,
      },
      {
        key: 'name',
        labelKey: 'i18n.shared.fields.name',
        control: 'text',
        validators: [Validators.required],
        colMd: 12,
      },
      {
        key: 'address',
        labelKey: 'i18n.shared.fields.address',
        control: 'text',
        colMd: 12,
      },
      {
        key: 'zip',
        labelKey: 'i18n.shared.fields.zip',
        control: 'text',
        validators: [CustomValidatorsFactory.createZipValidator()],
        colMd: 6,
      },
      {
        key: 'city',
        labelKey: 'i18n.shared.fields.city',
        control: 'text',
        colMd: 6,
      },
      {
        key: 'email',
        labelKey: 'i18n.shared.fields.email',
        control: 'email',
        validators: [Validators.email],
        colMd: 6,
      },
      {
        key: 'phoneNumber',
        labelKey: 'i18n.shared.fields.phone',
        control: 'text',
        validators: [CustomValidatorsFactory.createPhoneValidator()],
        colMd: 6,
      },
      {
        key: 'isActive',
        labelKey: 'i18n.shared.fields.active',
        control: 'checkbox',
        defaultValue: true,
        hiddenOnAdd: true,
        colMd: 12,
      },
    ],
    layout: [
      { fields: ['name'] },
      { fields: ['address'] },
      { fields: ['zip', 'city'] },
      { fields: ['email', 'phoneNumber'] },
      { fields: ['isActive'] },
    ],
  },
  mapToCreate: (formValue: ClientEditModel): CreateClientDTO => {
    return new CreateClientDTO({
      name: formValue.name!,
      address: formValue.address,
      zip: formValue.zip,
      city: formValue.city,
      email: formValue.email,
      phoneNumber: formValue.phoneNumber,
    });
  },
  mapToUpdate: (formValue: ClientEditModel): ClientEditModel => {
    return new UpdateClientDTO({
      id: formValue.id,
      name: formValue.name,
      address: formValue.address,
      zip: formValue.zip,
      city: formValue.city,
      email: formValue.email,
      phoneNumber: formValue.phoneNumber,
      isActive: formValue.isActive,
    });
  },
});
